import { FormEvent, ReactNode } from 'react';
import {
	Button,
	Drawer,
	DrawerBody,
	DrawerCloseButton,
	DrawerContent,
	DrawerFooter,
	DrawerHeader,
	DrawerOverlay,
	Flex,
	Spinner,
	Stack,
	Text
} from '@chakra-ui/react';

type DrawerFormProps = {
	isOpen: boolean;
	/** Fecha o drawer, ja com o descarte das edicoes e o refresh do pai. */
	onClose: () => void;
	titulo: string;
	/** Precisa ser unico por drawer: liga o botao Salvar ao <form> do corpo. */
	formId: string;
	loading: boolean;
	loadingLabel?: string;
	onSubmit: (event: FormEvent<HTMLFormElement>) => void;
	/** Botao destrutivo, ancorado a esquerda e longe do Salvar. */
	acaoDestrutiva?: ReactNode;
	children: ReactNode;
};

/**
 * Casca comum dos formularios em drawer: cabecalho, estado de carregando,
 * corpo em <form> e rodape com Voltar/Salvar.
 *
 * O botao Salvar mora no DrawerFooter, fora do <form>, e se liga a ele pelo
 * atributo form - assim o clique e o Enter passam pelo mesmo submit, com a
 * validacao no caminho.
 */
export const DrawerForm = ({
	isOpen,
	onClose,
	titulo,
	formId,
	loading,
	loadingLabel = 'Carregando...',
	onSubmit,
	acaoDestrutiva,
	children
}: DrawerFormProps) => {
	return (
		<Drawer isOpen={isOpen} placement="right" size={{ base: 'full', md: 'md' }} onClose={onClose}>
			<DrawerOverlay />
			<DrawerContent>
				<DrawerCloseButton />
				<DrawerHeader borderBottomWidth="1px">{titulo}</DrawerHeader>

				<DrawerBody>
					{loading ? (
						<Flex width="100%" height="90%" justifyContent="center" alignItems="center" flexDir="column">
							<Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
							<Text fontSize="24px" fontWeight="bold">
								{loadingLabel}
							</Text>
						</Flex>
					) : (
						<form id={formId} onSubmit={onSubmit} noValidate>
							<Stack spacing="20px">{children}</Stack>
						</form>
					)}
				</DrawerBody>

				<DrawerFooter borderTopWidth="1px" justifyContent={acaoDestrutiva ? 'space-between' : 'flex-end'}>
					{acaoDestrutiva}
					<Flex>
						<Button variant="outline" mr={3} onClick={onClose} isDisabled={loading}>
							Voltar
						</Button>
						<Button colorScheme="blue" type="submit" form={formId} isLoading={loading} isDisabled={loading}>
							Salvar
						</Button>
					</Flex>
				</DrawerFooter>
			</DrawerContent>
		</Drawer>
	);
};
